<template>
  <div>
    <el-dialog
      title="修改权重"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
    <!--工具条-->
    <el-form :model="filters" :rules="rules" class="toolbar" ref="filters" label-width="80px">
      <el-row style="padding-bottom: 0px;">
        <el-col :span="6">
          <el-form-item label="申请单号" prop="mrId">
            <el-input v-model="filters.mrId" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品大类" prop="dept">
            <el-input v-model="filters.dept" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div style="display:flex;">
            <el-form-item label="选品模式" prop="mrdMode">
              <el-select v-model="filters.mrdMode" placeholder="请选择"  disabled>
                <el-option label="季节性选品" value="1"></el-option>
                <el-option label="非季节性选品" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="mrdIndication" class="leftModelNolabel">
              <el-select v-model="filters.mrdIndication" placeholder="请选择"  disabled>
                <el-option label="上半年" value="1"></el-option>
                <el-option label="下半年" value="2"></el-option>
                <el-option label="夏季" value="3"></el-option>
                <el-option label="冬季" value="4"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row  style="padding-bottom: 0px;">
          <el-col :span="12">
            <el-form-item label="棚格图分类" prop="spaceclassNew">
            <el-select
              v-model="filters.spaceclassNew"
              filterable
              placeholder="请选择"
              disabled
              @change="numWeightSearch"
            >
              <el-option
                v-for="(item,i) in List"
                :key="i"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
          <el-form-item label="细分类" prop="ssubclass">
            <el-select
              v-model="filters.ssubclass"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item,i) in ssubList"
                :key="i"
                :label="item.ssubclass + ' ' + item.ssubName"
                :value="item.ssubclass"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="leftNolabel">
            <!-- <el-button type="primary" @click="search('filters')">
              <i class="el-icon-search"></i>查询
            </el-button> -->
            <el-button  @click="handleAdd(null,-1,'firstTarget')">新增一级指标</el-button>
            <el-button v-if="weightList&&weightList.length>0" @click="updateAppdetailList(null)">提交</el-button>

          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      :data="weightList"
      style="width: 100%">
      <el-table-column label="一级指标" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.mrdPid==null">{{scope.row.mrdKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="二级指标" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.mrdPid!=null">{{scope.row.mrdKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="占比" width="180">
        <template slot-scope="scope">
          <span><el-input size='mini' v-model="scope.row.mrdPercentage" style="width:50%"></el-input></span><span>%</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="取值范围">
        <template slot-scope="scope">
          <div style="display:flex;">
          <el-input size='mini' v-model="scope.row.mrdRangeStart" style="width:50%"></el-input>
          <el-input size='mini' v-model="scope.row.mrdRangeEnd" style="width:50%"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" style="padding:3px;" @click.stop="handleAdd(scope.row.mrdId,scope.$index,'secondTarget')" v-if="scope.row.mrdPid == null">新增二级指标</el-button>
          <el-button size="small" type="danger" style="padding:3px;" @click.stop="handleDel(scope.row,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增指标 -->
    <AddIndex  v-if="addVisible" :visible.sync="addVisible" :mrId="filters.mrId+''" :mrdPid="mrdPid" :rowIndex="rowIndex" :addType="addType" :weightList.sync="weightList" :filtersList.sync="filters"></AddIndex>
    <div slot="footer" class="dalog-footer">
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AddIndex from "@/views/selectgoods/selectionmanagement/rules/addIndex";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pogList: {
      type: Array,
      default(){
        return []
      }
    },
    viewFormDetail: {
      type: Object,
      default() {
          return {}
      }
    }
  },
  data() {
    return {
      filters: {
        dept: "",
        mrdMode: "",
        mrdIndication: "",
        spaceclassNew: "",
        ssubclass: "",
      },
      addVisible: false,
      disableDept: false,
      disableMrId: false,
      disableMrdIndication: false,
      disableMrdMode: false,
      disableSpaceclassNew: false,
      mrdPid: null,
      rowIndex: -1,
      List: [],
      ssubList:[],
      weightList: [],
      addType:'',
      rules: {
        // ssubclass: [
        //   { required: true, message: '请选择细分类', trigger: 'change' }
        // ]
      },
      form: {}
    };
  },
  components: {
    AddIndex
  },
  methods: {
    handleClose(){
      this.$emit('update:visible', false);
      this.$refs["filters"].resetFields();
    },
    //根据申请单号查询权重指标
    search(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.numWeightSearch();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    numWeightSearch(){
      let para = {};
      if(this.filters.spaceclassNew.indexOf(",") > -1){
        para={
          mrId: this.filters.mrId,
        };
      }else{
        para={
          mrId: this.filters.mrId,
          mrdPogcode: this.filters.spaceclassNew,
        };
      }
      
      this.$api.selectgoods.getShowAppdetailList(para).then(res => {
        this.weightList = res.data.result;
        this.listLoading = false;
      });
    },

    //选品规则 权重修改
    updateAppdetailList(){
      // console.log(this.weightList);
      let para = {
        appDetails: JSON.stringify(this.weightList)
      };
      // console.log(para);
      let msg = "";
      if(this.parentPercentage != 100){
        msg += "当前一级指标占比总和应该为100%,当前一级指标占比总和为"+this.parentPercentage+"%,请修改后提交；"
      }
      let childrenList=[];
      let sum = 0;
      let name = ""
      for(let key in this.childrenMap){
        childrenList = this.childrenMap[key];
        sum=0;
        for(let i=0;i<childrenList.length;i++){
          sum += +childrenList[i].mrdPercentage;
        }
        if(sum != 100){
          name = key.split(",")[1];
          msg +="一级指标" + name + "下的二级指标占比总和应该为100%，当前为："+sum+"%,请修改后提交；"
        }
      }
      if(msg.length>0){
        this.$message({
          message: msg,
          type: 'error'
        });
        return;
      }
      
      this.$api.selectgoods.updateAppdetailList(para).then(res => {
        if(res.data.code=='0000'){
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.handleClose();
        }else{
          this.$message({
            message: res.data.code,
            type: 'error'
          });
        }
      });
    },
    childrenPercentage(pid){
      var childrenList = this.childrenMap[pid];
      var sum = 0;
      for(var i = 0; i<childrenList.length; i++){
        sum += +childrenList[i].mrdPercentage;
      };
      return sum;
    },
    handleAdd(mrdPid,index,type){
      this.mrdPid = mrdPid;
      this.rowIndex = index;
      this.addType = type;
      this.addVisible=true;
    },
    handleDel(row,index){
      let _this = this;
      this.$confirm("确认删除该条指标吗?", "提示", {
        type: "warning"
      }).then(() => {
          _this.listLoading = true;
          let para = {
            "mrdId" : row.mrdId + ""
          };
          _this.$api.selectgoods.deleteRulealterAppDetail(para).then(res => {
            if(res.data.code === "0000"){
              this.$message("删除成功！");
              this.deteleRow(row,index);
            }else{
              this.$message("删除失败！");
            }
            // _this.search("filters");
          });
        })
        .catch(() => {});
    },
    deteleRow(row,index){
      if(row.mrdPid != null){
        this.weightList.splice(index,1);
      }else{
        this.weightList.splice(index,1);
        this.weightList = this.weightList.filter(function(item) {
          return item.mrdPid != row.mrdId
        });
      }
    }
  },
  computed: {
    parentPercentage(){
      var sum = 0;
      for(var i = 0; i<this.weightList.length; i++){
        if(this.weightList[i].mrdPid==null){
          sum += Number(this.weightList[i].mrdPercentage);
        }
      };
      return sum;
    },
    childrenMap(){
      var childrenList = {};
      let pid;
      let pName;
      for(var i=0; i<this.weightList.length; i++){
        pid = this.weightList[i].mrdPid;
        
        if(pid==null){
          pName = this.weightList[i].mrdKeyName;
          childrenList[this.weightList[i].mrdId+","+pName] = [];
        }else{
          childrenList[pid+","+pName].push(this.weightList[i]);
        }
      }
      return childrenList;
    }
    
  },
  created() {
    // console.log(this.viewFormDetail.mrId);
    this.filters.dept = this.viewFormDetail.dept;
    this.List = this.pogList;
    this.filters.spaceclassNew = this.List.toString();
    this.filters.mrId = this.viewFormDetail.mrId;
    this.filters.mrdMode = this.viewFormDetail.mrdMode;
    this.filters.mrdIndication = this.viewFormDetail.mrdIndication;
    this.$nextTick(() => {
      this.search('filters');
    })
  },
};
</script>




// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/update/weightSetUpdate.vue